@if(this.nbDaysRemaining !== null){
    <marv-tag class="days_remaining" [color]="this.getColorRemainingDays(this.nbDaysRemaining)" [size]="this.size">     
        @if(this.typeDaysRemaining === 'open'){
            @if(this.nbDaysRemaining >= 0){ 
                {{'PLANNING_START' | translate}} {{'DAY_SHORT' | translate}}-{{this.nbDaysRemaining}}
            }
            @else{
                {{'PLANNING_STARTED' | translate}}
            }
        }
        @else if(this.typeDaysRemaining === 'close'){
            @if(this.nbDaysRemaining >= 0){ 
                {{'PLANNING_END' | translate}} {{'DAY_SHORT' | translate}}-{{this.nbDaysRemaining}}
            }
            @else{
                {{'PLANNING_ENDED' | translate}}
            }
        }
    </marv-tag>
}

